<template>
	<div>
		<FormAula
			:aula="aulaEdit"
			:cursoId="cursoId"
			:materias="materias"
			:typeForm="typeForm"
			@changeTypeForm="changeTypeForm"
			v-if="showFormAula"
		></FormAula>

		<FormVideo
			:aulaId="aulaId"
			@changeTypeForm="changeTypeForm"
			v-if="showFormVideo"
		></FormVideo>

		<PlayerDialog :aula="aula" v-if="dialogPlayer"></PlayerDialog>

		<v-row v-if="aulas">
			<v-col
				cols="12"
				lg="6"
				md="6"
				sm="12"
				xs="12"
				class="d-flex flex-column"
				v-for="aula in aulas"
				:key="aula.id"
			>
				<v-card
					:color="colorAula(aula.mostrar, archiveAula)"
					dark
					class="elevation-5 flex d-flex flex-column"
				>
					<v-card-actions>
						<v-spacer></v-spacer>

						<v-btn
							@click="ordenationAula('up', aula)"
							class="btn-square"
							outlined
							title="ordenar"
						>
							<v-icon>fal fa-angle-up</v-icon>
						</v-btn>
						<v-btn
							@click="ordenationAula('down', aula)"
							class="btn-square"
							outlined
							title="ordenar"
						>
							<v-icon>fal fa-angle-down</v-icon>
						</v-btn>

						<v-btn
							class="btn-square"
							outlined
							title="Editar aula"
							@click="formAula(aula)"
							><v-icon small>fal fa-pen-alt</v-icon></v-btn
						>

						<v-btn
							class="btn-square"
							@click="formVideo(0, aula.id)"
							outlined
							title="Adicionar vídeo"
						>
							<v-icon small>fal fa-video-plus</v-icon>
						</v-btn>
					</v-card-actions>

					<v-divider></v-divider>
					<v-card-title class="headline">
						<v-btn
							class="btn-square mr-2"
							title="Abrir player"
							@click="player(aula)"
							v-if="aula.video > 0"
						>
							<v-icon small>fas fa-play</v-icon></v-btn
						>
						<v-chip label small outlined class="mr-1" title="ID">
							{{ aula.id }}
						</v-chip>
						{{ aula.nome }}
					</v-card-title>

					<v-expansion-panels
						v-if="aula.descricao"
						accordion
					>
						<v-expansion-panel v-if="aula.descricao">
							<v-expansion-panel-header>Descrição</v-expansion-panel-header>
							<v-expansion-panel-content>
								<span
									v-html="aula.descricao"
									class="ql-editor-custom ql-editor-custom-dark v-expansion-panel-content-custom"
								></span>
							</v-expansion-panel-content>
						</v-expansion-panel>
					</v-expansion-panels>
				</v-card>
			</v-col>
		</v-row>
	</div>
</template>
<script>
import { mapState } from 'vuex'

import FormAula from '@/components/admin/FormAula'
import FormVideo from '@/components/admin/FormVideo'
import PlayerDialog from '@/components/PlayerDialog'
export default {
	inheritAttrs: false,
	components: {
		FormAula,
		FormVideo,
		PlayerDialog,
	},
	props: {
		aulas: undefined,
		materias: undefined,
		archiveAula: undefined,
	},
	data() {
		return {
			server: 'aula',
			showFormAula: false,
			showFormVideo: false,
			showPlayer: false,
			aulaEdit: {},
			cursoId: null,
			aulaId: null,
		}
	},
	computed: {
		...mapState(['user', 'XMLHttpRequest', 'dialogPlayer']),
	},
	methods: {
		colorAula(active, archive) {
			if (archive == true) {
				return 'orange'
			} else if (active == true) {
				return 'green darken-1'
			} else {
				return 'grey darken-1'
			}
		},
		formAula(aula) {
			this.typeForm = 1
			this.aulaEdit = Object.assign({}, aula)
			this.showFormAula = true
			setTimeout(() => {
				this.$store.dispatch('dialogAula', { value: true })
			}, 300)
		},
		formVideo(type, aulaId) {
			this.aulaId = aulaId
			this.showFormVideo = true
			this.typeForm = type
			setTimeout(() => {
				this.$store.dispatch('dialogVideo', { value: true })
			}, 300)
		},
		player(aula) {
			this.aula = aula
			this.showPlayer = true
			setTimeout(() => {
				this.$store.dispatch('dialogPlayer', { value: true })
			}, 300)
		},
		changeTypeForm(value) {
			this.typeForm = value.typeForm
			if (value.hideForm == 'aula') {
				this.showFormAula = false
			}
			if (value.hideForm == 'video') {
				this.showFormVideo = false
			}
		},
		ordenationAula(type, aula) {
			let formData = new FormData()
			formData.append('menu', 'aula')
			formData.append('function', 'order_aula')
			formData.append('user_id', this.user.id)
			formData.append('curso_id', aula.curso_id)
			formData.append('materia_id', aula.materia_id)
			formData.append('id', aula.id)
			formData.append('ordenation', aula.ordenation)
			formData.append('archive', this.archiveAula)
			formData.append('type', type)
			let vd = this
			this.$axiosPost
				.post('functions.php', formData, {
					headers: { Authorization: this.user.token },
				})
				.then(function(response) {
					if (response.data.error === 0) {
						vd.$store.dispatch('alert', {
							alertMessage: response.data.alertMessage,
							alertType: 0,
						})
						vd.$store.dispatch('searchAula', { value: true })
					} else {
						vd.$store.dispatch('errorServer', {
							data: response.data,
							destino: vd.$route.path,
						})
					}
				})
				.catch(function(response) {
					console.log('ERROR!! ' + response)
				})
		},
	},
}
</script>
<style lang="css" scoped>
.table-actions {
	min-width: 73px;
	padding: 0;
}
.v-expansion-panel-content-custom {
	display: block !important;
}
.v-expansion-panel-content {
	overflow-x: hidden !important;
}
.ql-editor-custom {
	padding: 12px 0 !important;
}
</style>
